import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createAccount, getAccountItem as _getAccountItem, updateAccount } from "@api/correspondence/task";
import validate from "@/validate/validate";
import { getList } from "@/api/setting/dictionary";
export default {
  name: "balance",
  computed: {
    text: function text() {
      var text = {
        '截止': '期末余额(RMB元)',
        '期间': '期间发生额'
      };
      return text[this.form.c12TimeType];
    }
  },
  props: {
    uid: {
      required: true
    },
    id: {
      default: function _default() {
        return undefined;
      }
    },
    type: {
      default: function _default() {
        return 'new';
      }
    }
  },
  data: function data() {
    return {
      options: [],
      form: {
        c12Time: undefined,
        c12TimeType: '截止',
        c12AccountName: undefined,
        c12AccountSum: undefined,
        c12ConfirmBackRatio: undefined,
        c12ConfirmBackSum: undefined,
        c12ConfirmSendRatio: undefined,
        c12ConfirmSendSum: undefined,
        c12EditDate: undefined,
        c12StaffName: undefined,
        c12Id: undefined
      },
      rules: {
        c12Time: [{
          required: true,
          message: '请选择截止日期',
          trigger: 'change'
        }],
        c12TimeType: [{
          required: true,
          message: '请选择日期类型',
          trigger: 'change'
        }],
        c12AccountName: [{
          required: true,
          message: '请选择科目名称',
          trigger: 'change'
        }],
        c12AccountSum: [{
          required: true,
          message: '期末余额或期间发生额不能为空',
          trigger: 'change'
        }, {
          validator: validate.isNum,
          message: '请输入正确的数字',
          trigger: 'change'
        }]
      },
      loading: false,
      etag: undefined
    };
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data, _yield$_this$$awaitTo3, _yield$_this$$awaitTo4, _err, _data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$checkForm();
            case 1:
              _this.loading = true;
              if (!(_this.type === 'new')) {
                _context.n = 4;
                break;
              }
              _context.n = 2;
              return _this.$awaitTo(createAccount(_this.uid, _this.form));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.n = 6;
              break;
            case 4:
              _context.n = 5;
              return _this.$awaitTo(updateAccount(_this.uid, _this.form.c12Id, _this.form, {
                'If-Match': _this.etag
              }));
            case 5:
              _yield$_this$$awaitTo3 = _context.v;
              _yield$_this$$awaitTo4 = _slicedToArray(_yield$_this$$awaitTo3, 2);
              _err = _yield$_this$$awaitTo4[0];
              _data = _yield$_this$$awaitTo4[1];
              _this.loading = false;
              if (!_err) {
                _context.n = 6;
                break;
              }
              return _context.a(2);
            case 6:
              _this.$message.success('操作成功');
              _this.$emit('submit');
            case 7:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getAccountItem: function getAccountItem() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, res, data, etag;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.$awaitTo(_getAccountItem(_this2.uid, _this2.id));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              res = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              data = res.data;
              etag = res.headers.etag;
              _this2.etag = etag;
              _this2.form = data;
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getOptions: function getOptions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$awaitTo(getList({
                page: 1,
                length: 99999,
                type: 'c12AccountName'
              }));
            case 1:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              data = _yield$_this3$$awaitT2[1].data;
              if (!err) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              if (Array.isArray(data.datas)) {
                _this3.options = data.datas;
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    if (this.id) {
      this.getAccountItem();
    }
    this.getOptions();
  }
};